import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
})

export const adminMenu = new Vuex.Store({
  state: {
    menuOpenStatus: false
  },
  mutations: {
    menuChange (state, payload) {
      state.menuOpenStatus = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js